<div class="app-loading">
  <div class="logo"></div>
</div>

<p>Processing request</p>
